import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Button, Heading, Flex, useModal, AutoRenewIcon, Text, TrophyGoldIcon } from '@pancakeswap/uikit'
import { useWeb3React } from '@pancakeswap/wagmi'
import { FetchStatus, LotteryStatus } from 'config/constants/types'
import { useTranslation } from '@pancakeswap/localization'
import { useGetUserLotteriesGraphData, useLottery } from 'state/lottery/hooks'
import ConnectWalletButton from 'components/ConnectWalletButton'
import ClaimPrizesModal from './ClaimPrizesModal'
import useGetUnclaimedRewards from '../hooks/useGetUnclaimedRewards'

const StyledFlex = styled(Flex)`
  padding: 20px;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px; 
  width: 100%;
  margin-left: 8px;
  margin-right: 8px;
  @media (min-width: 680px) {
    margin-left: auto;
    margin-right: auto;
  }
  max-width: 680px;
  border-radius: 30px;
  border: 1px solid rgba(243, 238, 255, 0.08);
  background: linear-gradient(180deg, rgba(243, 238, 255, 0.00) 0%, rgba(243, 238, 255, 0.04) 100%), rgba(147, 130, 255, 0.01);
  box-shadow: 0px 0px 12px 0px rgba(255, 255, 255, 0.08) inset;
  @media (min-width: 1280px) {
    position: absolute;
    right: 15px;
    top: 0;
    width: 400px;
`

const CustomButton = styled(Button)`
  padding: 15px 20px 16px 20px !important;; 
  font-size: 18px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: 140%;
  font-family: DM Sans !important;
  height: 44px !important;
  background: transparent !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  box-shadow: none !important;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder} !important;
`

const TicketImage = styled.img`
  height: 60px;
  ${({ theme }) => theme.mediaQueries.sm} {
    height: 100px;
  }
`

const TornTicketImage = styled.img`
  height: 54px;
  ${({ theme }) => theme.mediaQueries.sm} {
    height: 84px;
  }
`

const CheckPrizesSection = () => {
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const {
    isTransitioning,
    currentRound: { status },
  } = useLottery()
  const { fetchAllRewards, unclaimedRewards, fetchStatus } = useGetUnclaimedRewards()
  const userLotteryData = useGetUserLotteriesGraphData()
  const [hasCheckedForRewards, setHasCheckedForRewards] = useState(false)
  const [hasRewardsToClaim, setHasRewardsToClaim] = useState(false)
  const [onPresentClaimModal] = useModal(<ClaimPrizesModal roundsToClaim={unclaimedRewards} />, false)
  const isFetchingRewards = fetchStatus === FetchStatus.Fetching
  const lotteryIsNotClaimable = status === LotteryStatus.CLOSE
  const isCheckNowDisabled = !userLotteryData.account || lotteryIsNotClaimable

  useEffect(() => {
    if (fetchStatus === FetchStatus.Fetched) {
      // Manage showing unclaimed rewards modal once per page load / once per lottery state change
      if (unclaimedRewards.length > 0 && !hasCheckedForRewards) {
        setHasRewardsToClaim(true)
        setHasCheckedForRewards(true)
        onPresentClaimModal()
      }

      if (unclaimedRewards.length === 0 && !hasCheckedForRewards) {
        setHasRewardsToClaim(false)
        setHasCheckedForRewards(true)
      }
    }
  }, [unclaimedRewards, hasCheckedForRewards, fetchStatus, onPresentClaimModal])

  useEffect(() => {
    // Clear local state on account change, or when lottery isTransitioning state changes
    setHasRewardsToClaim(false)
    setHasCheckedForRewards(false)
  }, [account, isTransitioning])

  const getBody = () => {
    if (!account) {
      return (<></>
        // <StyledFlex alignItems="center" justifyContent="center">
        //   <Flex mx={['4px', null, '16px']} flexDirection="column" alignItems="center">
        //     <Heading textAlign="center" color="#F4EEFF">
        //       {t('Connect your wallet')}
        //     </Heading>
        //     <Heading textAlign="center" color="#F4EEFF" mb="24px">
        //       {t("to check if you've won!")}
        //     </Heading>
        //     <ConnectWalletButton width="190px" />
        //   </Flex>
        // </StyledFlex>
      )
    }
    if (hasCheckedForRewards && !hasRewardsToClaim) {
      return (
        <StyledFlex alignItems="center" justifyContent="center">
          <Flex mx={['4px', null, '16px']} flexDirection="column">
            <Text textAlign="center" color="#F4EEFF">
              {t('No prizes to collect')}
            </Text>
            <Text textAlign="center" color="textSubtle">
              {t('Better luck next time!')}
            </Text>
          </Flex>
        </StyledFlex>
      )
    }
    if (hasCheckedForRewards && hasRewardsToClaim) {
      return (
        <StyledFlex alignItems="center" justifyContent="center">
          {/* <TicketImage src="/images/lottery/ticket-l.png" alt="lottery ticket" /> */}
          <Flex mx={['4px', null, '16px']} flexDirection="column">
            <Heading textAlign="center" color="#F4EEFF">
              {t('Congratulations!')}
            </Heading>
            <Heading textAlign="center" color="#F4EEFF">
              {t('Why not play again')}
            </Heading>
          </Flex>
          {/* <TicketImage src="/images/lottery/ticket-r.png" alt="lottery ticket" /> */}
        </StyledFlex>
      )
    }
    const checkNowText = () => {
      if (lotteryIsNotClaimable) {
        return `${t('Calculating')}...`
      }
      if (isFetchingRewards) {
        return t('Checking')
      }
      return t('Check now')
    }
    return (
      <StyledFlex alignItems="center" justifyContent="center" m='auto'>
        <Flex flexDirection={['column', 'column', 'column', 'row']} style={{gap: '15px'}} alignItems='center'>
          <TrophyGoldIcon fill='#9F9DAE' height='24px' width='24px' />
          <Text textAlign="center" color="#F4EEFF">
            {t('Are you a winner?')}
          </Text>
          <CustomButton
            disabled={isCheckNowDisabled}
            onClick={fetchAllRewards}
            isLoading={isFetchingRewards}
            endIcon={isFetchingRewards ? <AutoRenewIcon color="currentColor" spin /> : null}
          >
            {checkNowText()}
          </CustomButton>
        </Flex>
      </StyledFlex>
    )
  }

  return <Flex>{getBody()}</Flex>
}

export default CheckPrizesSection
